import React from 'react';
import { bool } from 'prop-types';
import { Box, Typography, useTheme } from '@mui/material';
import { labelTextStyles } from '../SupplierAuthCard.styles';

const SupplierAuthLimitLabel = ({ active }) => {
  const theme = useTheme();
  const supplierLabel = active ? 'Active' : 'Inactive';

  return (
    <Box
      alignItems="center"
      bgcolor={active ? theme.palette.secondary.light : theme.palette.graphic.lighter}
      borderRadius="4px"
      display="flex"
      height="61px"
      justifyContent="center"
      m={1}
      p={0.5}
      textAlign="center"
    >
      <Typography color="textPrimary" sx={labelTextStyles} variant="subtitle2">
        {supplierLabel}
      </Typography>
    </Box>
  );
};

export default SupplierAuthLimitLabel;

SupplierAuthLimitLabel.propTypes = {
  active: bool.isRequired,
};
